var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-text"},[_c('q-text',{attrs:{"disabled":_vm.disabled},on:{"blur":_vm.returnAnswer},model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }